import React from 'react';

import cx from 'classnames';

import ButtonLoader from './../buttonLoader/ButtonLoader';
import Icon from '../icons';

import styles from './button.module.scss';

interface Props {
  children: React.ReactNode;
  type?: 'Primary' | 'Secondary' | 'Outline';
  size?: 'Small' | 'Medium' | 'Large';
  disabled?: boolean;
  prefixIcon?: string | React.ReactNode;
  suffixIcon?: string | React.ReactNode;
  isLoading?: boolean;
  className?: string;
  prefixIconClassName?: string;
  suffixIconClassName?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onSuffixIconClick?: () => void;
  onPrefixIconClick?: () => void;
  width?: string;
  height?: string;
}

const Button: React.FC<Props> = (props) => {
  const {
    children,
    type,
    prefixIcon,
    suffixIcon,
    disabled,
    isLoading,
    className,
    prefixIconClassName,
    suffixIconClassName,
    onClick,
    onPrefixIconClick,
    onSuffixIconClick,
    width,
    height,
    size,
  } = props;

  // const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
  //   if (onClick) onClick(e);
  // };

  return (
    <button
      disabled={disabled}
      style={{ width: width, height: height }}
      className={cx(
        styles.button,
        { [styles.secondaryButton]: type === 'Secondary' },
        { [styles.primaryButton]: type === 'Primary' },
        { [styles.outlineButton]: type === 'Outline' },
        { [styles.disabled]: disabled },
        { [styles.iconButton]: prefixIcon || suffixIcon },
        { [styles.smallButton]: size === 'Small' },
        { [styles.mediumButton]: size === 'Medium' },
        { [styles.largeButton]: size === 'Large' },
        className,
      )}
      onClick={onClick}
    >
      {prefixIcon && !isLoading && (
        <div className={cx(styles.prefixIcon, prefixIconClassName)}>
          <Icon icon={prefixIcon} onClick={onPrefixIconClick} />
        </div>
      )}

      {isLoading ? <ButtonLoader active={type === 'Outline'} className={''} /> : <p>{children}</p>}

      {suffixIcon && !isLoading && (
        <div className={cx(styles.suffixIcon, suffixIconClassName)}>
          <Icon icon={suffixIcon} onClick={onSuffixIconClick} />
        </div>
      )}
    </button>
  );
};

export default Button;
